import { Routes, Route, Navigate } from "react-router-dom";
import HomePage from "../pages/Home/HomePage";

const HomeRoutes: React.FC = () => {
  return (
    <Routes>
      <Route index element={<HomePage />} />
      <Route path="/*" element={<Navigate to="../" />} />
    </Routes>
  );
};

export default HomeRoutes;
